import * as React from 'react';

import { SummaryProps, SummaryState } from './types';
import './Summary.scss';
import SummaryMain from './SummaryMain';

class Summary extends React.Component<SummaryProps, SummaryState> {
  constructor(props: SummaryProps) {
    super(props);
    this.state = {
      typeCheck: true,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: SummaryProps) {
    if (nextProps.alfaId !== this.props.alfaId) {
      this.setState({ typeCheck: true });
    }
  }

  handleClick = () => {
    const typeCheck = !this.state.typeCheck;

    this.setState({ typeCheck });
  };

  render() {
    return (
      <SummaryMain
        tableHeader={this.props.tableHeader}
        tableInfo={this.props.tableInfo}
        handleClick={this.handleClick}
        typeCheck={this.state.typeCheck}
        typeStage={this.props.typeStage}
        alfaId={this.props.alfaId}
        path={this.props.path}
        isSimulation={this.props.isSimulation}
      />
    );
  }
}

export default Summary;
